export default function filterInvoicesDeliveryEntities(enrichedInvoices, filters = {}) {
  // Filtre par entité (basé sur flux_type dans metadata)
  const entityMapping = {
    'WGUK': 'uk-vente',
    'WGE': 'eu-vente',
  }
  const currencyMapping = {
    '€': 'eur',
    '£': 'gbp',
    '$': 'usd',
    'C$': 'cad',
    'C€': 'chf',
  }
  return enrichedInvoices.filter(invoice => {
    if (filters.entity && filters.entity !== 'ALL') {
      const fluxType = invoice.metadata?.find(m => m.key === 'flux_type')?.value
      if (fluxType !== entityMapping[filters.entity]) return false
    }
    if (filters.currency && filters.currency !== 'ALL') {
      if (invoice.currency !== currencyMapping[filters.currency]) return false
    }
    if (filters.period === 'YTD') {
      const invoiceDate = new Date(invoice.created_at)
      const currentDate = new Date()
      const startOfYear = new Date(currentDate.getFullYear(), 0, 1)
      if (invoiceDate < startOfYear || invoiceDate > currentDate) return false
    }
    return true
  })
} 